import Vue from 'vue'
import Router from 'vue-router'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// import {store} from '../store/store'
// import menuList from '../components/code'
// import { filterAsyncRoutes } from '@/utils/asyncRouter.js'
// import fetch from '../api/fetch'
// import qs from 'qs'

Vue.use(Router)

const routes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
       path: '/login',
       name: 'login',
       meta: {
         title: '登录',
       },
       component: ()=>import('@/views/login/login')
    },
    {
        path: '/homePage',
        name: 'homePage',
        meta: {
          title: '首页',
          roles: ['admin', 'user' ,'editor'] 
        },
        component: ()=>import('@/views/homePage/homePage'),
        children: [
            // 申请
            {
                path: 'mechanismOpenApply',
                name: 'mechanismOpenApply',
                meta: {
                    title: '机构开通申请',
                    roles: ['admin', 'user']
                },
                parrentId: 0,
                component: () => import('@/views/mechanismOpenApply/mechanismOpenApply.vue')
            },
            {
                path: 'mechanismPostApproval',
                name: 'mechanismPostApproval',
                meta: {
                    title: '机构申请审批',
                    roles: ['admin', 'user']
                },
                parrentId: 0,
                component: () => import('@/views/mechanismPostApproval/mechanismPostApproval.vue')
            },
            {
                path: 'insRegistrationView',
                name: 'insRegistrationView',
                meta: {
                    title: '机构注册查看',
                    roles: ['admin', 'user']
                },
                parrentId: 0,
                component: () => import('@/views/insRegistrationView/insRegistrationView.vue')
            },
            {
                path: 'websiteApproval',
                name: 'websiteApproval',
                meta: {
                    title: '机构注册查看',
                    roles: ['admin', 'user']
                },
                parrentId: 0,
                component: () => import('@/views/websiteApproval/websiteApproval.vue')
            },
            // 计划
            {
                path: 'applyPage',
                name: 'applyPage',
                meta: {
                    title: '大赛练习计划',
                    roles: ['admin', 'user']
                },
                parrentId: 1,
                component: () => import('../views/comPractice/comPractice.vue')
            },
            // 人员管理
            {
                path: 'personManagement',
                name: 'personManagement',
                meta: {
                    title: '人员管理',
                    roles: ['admin', 'user']
                },
                parrentId: 2,
                component: () => import('../views/personManagement/personManagement.vue')
            },
            {
                path: 'institutionalManagement',
                name: 'institutionalManagement',
                meta: {
                    title: '机构管理',
                    roles: ['admin', 'user']
                },
                parrentId: 2,
                component: () => import('../views/institutionalManagement/institutionalManagement.vue')
            },
            {
                path: 'RegWebsiteManagement',
                name: 'RegWebsiteManagement',
                meta: {
                    title: '报名官网管理',
                    roles: ['admin', 'user']
                },
                parrentId: 2,
                component: () => import('../views/RegWebsiteManagement/RegWebsiteManagement.vue')
            },
        ]
    },

    {
        path: '*',
        name: 'notFount',
        meta: {
            title: '404'
        },
        component: () => import('@/views/notFount/404.vue')
    }
]
/** 默认的路由存起来 用于动态添加 */
Vue.prototype.defaultRouters = routes

// console.log(asyncRouter)
/** 默认的路由存起来 用于动态添加 */
let Routers = new Router({
    mode: "hash",
    routes
})
// Routers.beforeEach(async ()=>{
    
// })
export default Routers